import React, { useEffect, useState } from "react";
import EdexBalence from "./components/EdexBalence";
import NetWorkBalance from "./components/NetWorkBalance";
import SelectNetwork from "./components/SelectNetwork";
import AmountPicker from "./components/AmountPicker";
import { EdexaIcon } from "../components/imgIcon";
import AmountPickerPercent from "./components/AmountPickerPercent";
import { useConnectWallet, useWallets, useSetChain } from "@web3-onboard/react";
import { ethers } from "ethers";
import ERC20ABI from "./../../../../assets/abi/erc20_ABI.json";
let erc20, provider,contract;
function FromNetWorkContainer({
  netWroks = [],
  setNetWroks,
  // tockens,
  // setTockens,
  setTransAmount,
  transAmount,
  handleClickOnMaxAmout,
  setIsInvalid,
  isInvalid,
  fromBalance
}) {
  const [{ chains, connectedChain, settingChain }, setChain] = useSetChain();
  // const [balance, setBalance] = React.useState(0);
  const [{ wallet, connecting }, connect, disconnect] = useConnectWallet();
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    setIsLoading(true)
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 1000);

    return () => clearTimeout(timer);
  }, [connectedChain]);



  function formatAmount(amount) {
    // Convert amount to string
    let amountStr = amount.toString();
  
    // Check if there is a decimal point
    if (amountStr.includes('.')) {
        // Split the string into integer and decimal parts
        let parts = amountStr.split('.');
        // Limit the decimal part to 3 digits
        parts[1] = parts[1].substring(0, 3);
        // Join the parts back together
        return parts.join('.');
    } else {
        // If there's no decimal point, return the amount with '.000'
        return amountStr + '.000';
    }
  }
  
  const handleChange = (event) => {
    const inputValue = event.target.value;
    // Regular expression to validate the input
    const regex = /^(0|[1-9]\d*)(\.\d{0,3})?$/;

    // Check if the input matches the regex or is empty
    if (inputValue === "" || regex.test(inputValue)) {
      setTransAmount(inputValue);
      // getBalance();
     if(Number(inputValue)>fromBalance||Number(inputValue)<=0){
      setIsInvalid(true)
     }else{
      setIsInvalid(false)
     }
    }
    }

  const setNetwrokForFrom = async(param) => {
  const changeSuccess= false;
    try{
      changeSuccess= await setChain ({chainId:param.chainId});
     }catch(e){
      // console.log("error occured during network shift");
      return  // stop here on error
    }


   if(!changeSuccess) return;
    setNetWroks((prev) => {
      const arr = [];
      for (let i = 0; i < prev.length; i++) {
        const element = prev[i];
        if (element.name === param.name) {
          element.isSelectedAsFrom = true;
          element.isSelectedAsFrom = false;
        }
        arr.push(element)
      }
      return [...arr]
    });
  };


  return (
    <div className="">
      <div className="rounded-t-lg px-4 pt-4 py-2 bg-sunny-primary dark:bg-dark-primary border-solid border-sunny-border dark:border-dark-border border-b ">
        <NetWorkBalance />
        <div className="flex py-1 justify-between">
          <SelectNetwork networks={netWroks} setNetwork={setNetwrokForFrom} />
          <div>
            {/* <EdexBalence networks={netWroks} /> */}
            {isLoading ? (
              <div className="w-4 h-4 border-4 border-t-4 border-gray-400 border-t-gray-600 rounded-full animate-spin"></div>
            ) : (
              <span className="font-semibold" style={{ fontSize: '13px',fontWeight:500 }}> {formatAmount(fromBalance.toString())} EDX</span> 
            )}
          </div>
        </div>
      </div>
      <div className="rounded-b-lg bg-sunny-primary dark:bg-dark-primary px-4 py-4 flex items-center justify-between">
        <div className=" flex items-center">
          <div className="border-solid py-3 dark:bg-dark-primary  border-sunny-border dark:border-dark-border border-r pr-5">
            <div className="flex items-center">
              <EdexaIcon />
              <p className="ml-2">EDX</p>
              {/* <SelectNetwork type="tocken" networks={tockens} setNetwork={setTockens} /> */}
            </div>
          </div>
          {/* <div className="pl-3 text-lg">00.00</div> */}
          <div className="pl-3 text-lg" style={{ color: isInvalid ? "red" : "black" }}>
            <AmountPicker value={transAmount} onChange={handleChange} isInvalid={isInvalid} />
          </div>
        </div>
        <AmountPickerPercent handleClickOnMaxAmout={handleClickOnMaxAmout} />
      </div>
    </div>
  );
}

export default FromNetWorkContainer